import React from "react";

interface Step {
  id: number;
  label: string;
}

interface StepperProps {
  steps: Step[];
  currentStep: number;
}

export const Stepper: React.FC<StepperProps> = ({ steps, currentStep }) => {
  return (
    <div className="w-full pb-6">
      <div className="flex items-center justify-center gap-6">
        {steps.map((step, index) => {
          const isCompleted = step.id < currentStep;
          const isCurrent = step.id === currentStep;

          return (
            <React.Fragment key={step.id}>
              {/* Step Circle */}
              <div className="flex flex-col items-center">
                <div
                  className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-white ${
                    isCompleted || isCurrent ? "bg-textPrimary" : "bg-gray-300 text-gray-600"
                  }`}
                >
                  {isCompleted ? "✓" : step.id}
                </div>
                <div className={`mt-2 text-xs text-center ${isCurrent ? "text-black" : "text-gray-500"}`}>
                  {step.label}
                </div>
              </div>

              {/* Connector Line più corta */}
              {index < steps.length - 1 && (
                <div className="w-16 h-0.5 flex items-center">
                  <div className={`w-full h-0.5 ${step.id < currentStep ? "bg-textPrimary" : "bg-gray-300"}`} />
                </div>
              )}
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};
